import axios from 'axios'

// Timpel Enlight Feature Server API (v1.0.14)
// Swagger spec: tts-feature-server_1.0.14_api.yml
const featureServerApi = axios.create({
  baseURL: '/feature-server',
  headers: {
    'X-Timpel-API-Key': process.env.VUE_APP_TIMPEL_HTTP_KEY_VALUE || '13f4075a842d02fd69e8da9601971676e899e5c63712ed3988770bf16e198d2e',
    'Content-Type': 'application/json'
  }
})
/**
 * GET /presets
 * Returns the list of available presets.
 * @returns {Promise<Array<{ id: number, name: string, description: string }>>}
 */
export const getPresets = () => featureServerApi.get('/presets')

/**
 * POST /activation
 * Activates a device with the given preset.
 *
 * @param {Object} deviceIdentity
 * @param {string} [deviceIdentity.equipment_serial_number]
 * @param {string} [deviceIdentity.pim_serial_number]
 * @param {string} [deviceIdentity.am_serial_number]
 * @param {string} [deviceIdentity.ventilation_board_serial_number]
 * @param {string} [deviceIdentity.pim_mac_address_one]  - format: "aa:bb:cc:dd:ee:ff"
 * @param {string} [deviceIdentity.pim_mac_address_two]  - format: "aa:bb:cc:dd:ee:ff"
 * @param {string} presetName - Name of the preset to activate
 * @returns {Promise<{ configFile: string, signature: string }>}  (base64-encoded values)
 */
export const activateDevice = (deviceIdentity, presetName) =>
  featureServerApi.post('/activation', {
    device: deviceIdentity,
    preset: presetName
  })

export default featureServerApi
